import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
// import Vimeo from  'react-vimeo';

import { BAND, MUSICIAN } from "../../../../consts";

// utils
import { clientMedia } from '../../../../Config/Settings'
import { formatMusicStyles, getYoutubeId, isVideo, vimeo_parser, capitalizeAll} from '../../../../utils';

// components

// svgs

// styles
import './MediaMobile.css';

const MEDIA_MOBILE_HEIGHT =  200;

class MediaMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReady: false,
            scrollPos: 0
        };

        this.scrollRef = {};
    }

    componentDidMount() {
        this.scrollRef.addEventListener('scroll', e => {
            this.scrolledEvent(e)
        }, { passive: true, capture: true })
    }

    componentWillUnmount() {
        if (!this || !this.scrollRef) return;
        this.scrollRef.removeEventListener('scroll', this.scrolledEvent);
    }

    scrolledEvent(e) {
        if (!this || !this.scrollRef) return;
        this.setState({scrollPos: this.scrollRef.scrollLeft})
    }

    getVideoYTId() {
        // url sturct = https://www.youtube.com/embed/D0W1v0kOELA
        return getYoutubeId(this.props.media[0]) || '';
    }

    getVideoVimeoUrl() {
        return vimeo_parser(this.props.media[0] || '');
    }

    renderEmbeddedVideoYT(id) {
        const opts = {
            height: MEDIA_MOBILE_HEIGHT, // this.props.mainMediaHeight.toString(),
            width: window.innerWidth, // this.props.mainMediaWidth.toString(),
            playerVars: { // https://developers.google.com/youtube/player_parameters
                autoplay: 0,
                showInfo: 0
            }
        };

        return (
            <YouTube
                className={this.state.isPlaying ? 'show' : 'show'}
                videoId={id}
                opts={opts}
            />
        )
    }

    renderEmbeddedVideoVimeo(vimeoUrl) {
        return (
            <iframe
                className="show"
                width={window.innerWidth}
                height={MEDIA_MOBILE_HEIGHT}
                frameBorder="0"
                src={vimeoUrl}
                title={vimeoUrl}
            ></iframe>
        )
    }

    // not in use - those are for out side usage - not in use for now
    scrollRight() {
        //this.scrollRef.scrollBy({left: window.innerWidth, behavior: 'smooth'})
    }

    scrollLeft() {
        //this.scrollRef.scrollBy({left: -window.innerWidth, behavior: 'smooth'})
    }

    handleMediaClick(index) {
    }

    renderMediaSlide(videoYTId, videoVimeoUrl) {
        // no images use case
        if (!this.props.media || this.props.media.length < 1) {
            return (
                <div className="image"
                     style={{
                        backgroundImage: `url(${clientMedia()}/img/logos/make-logo.png)`,
                        backgroundSize: 'contain'
                     }}
                >
                </div>
            )
        }

        return this.props.media.map((m, index) => {
            // case image
            if (!isVideo(m)) {
                return (
                    <div
                        key={`mobile-slider-media-${index}`}
                        className="image"
                        style={{backgroundImage: `url(${m})`}}
                    >
                    </div>
                )
            }

            if (videoYTId) {
                return (
                    <div
                        key={`mobile-slider-media-${index}`}
                        className={`video ${this.props.pin.type}`}
                        onClick={() => this.handleMediaClick(index)}
                    >
                        {this.renderEmbeddedVideoYT(videoYTId)}
                    </div>
                )
            }

            if (videoVimeoUrl) {
                // show here Vimeo thumbnail from pin data
                return (
                    <div
                        key={`mobile-slider-media-${index}`}
                        className={`video ${this.props.pin.type}`}
                        onClick={() => this.handleMediaClick(index)}
                    >
                        {this.renderEmbeddedVideoVimeo(videoVimeoUrl)}
                    </div>
                )
            }

            return null;
        })
    }

    renderSubCategories() {
        const tags = this.props.pin.type === BAND || this.props.pin.type === MUSICIAN ? [] : this.props.pin.subCategories;

        if (!tags) return null;

        return (
            <div className={`sub-categories-wrapper ${this.props.pin.type}`}>
                {tags.map((sub, index) => {
                    return (
                        <div
                            key={`sub-cats-slider-${sub}-${index}`}
                            className="sub-category">
                            {capitalizeAll(formatMusicStyles(sub, false, true))}
                        </div>
                    )
                })}
            </div>
        )
    }

    renderBullets(pinType) {
        return (
            <div className="scroller-bullets-wrapper">
                {this.props.media.map((image, index) => {
                    let isNotSelected = this.checkIsSelectedBullet(index);
                    if (index === 0 && this.scrollRef.scrollLeft === undefined) {
                        isNotSelected = false;
                    }

                    return (
                        <div key={`slider-bullet-${index}`} className={`bullet ${pinType} ${isNotSelected ? '' : 'selected'}`}></div>
                    )
                })}
            </div>
        )
    }

    checkIsSelectedBullet(index) {
        if (this.scrollRef.scrollLeft === undefined) return true;
        if (this.scrollRef.scrollLeft + window.innerWidth < (index + 1) * window.innerWidth - 150) return true;
        if (this.scrollRef.scrollLeft + window.innerWidth > (index + 1) * window.innerWidth + 150) return true;

        return false
    }

    render() {
        if (!this.props || !this.props.pin) return null;

        const videoYTId = this.getVideoYTId();
        const videoVimeoUrl = this.getVideoVimeoUrl();

        return (
            <div className="modal-media-mobile-wrapper" style={{width: window.innerWidth, ...this.props.wrapperStyle}}>
                {this.renderSubCategories()}

                <div
                    ref={ref =>  this.scrollRef = ref}
                    className="slide-wrapper"
                    style={{width: window.innerWidth}}
                >
                    {this.renderMediaSlide(videoYTId, videoVimeoUrl)}
                </div>
                {this.renderBullets(this.props.pin.type)}
            </div>
        )
    }
}

MediaMobile.propTypes = {
    pin: PropTypes.object,
    mainMediaHeight: PropTypes.number,
    media: PropTypes.array,
    wrapperStyle: PropTypes.object
};

MediaMobile.defaultProps = {
    mainMediaWidth: 500,
    mainMediaHeight: 600
};

export default MediaMobile;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/Media/MediaMobile.js